import React from "react";

const APP_NAME = "PlanB: AI Job Search App";
const COMPANY = "PlanB Foundation"; // change if your legal name differs
const CONTACT_EMAIL = "support@planbjobs.in"; // change to your real email
const RESPONSE_DAYS = 7;

const styles = {
  page: { background: "#f7f8fa", minHeight: "100vh", padding: "32px 16px" },
  card: {
    maxWidth: 820,
    margin: "0 auto",
    background: "#fff",
    borderRadius: 12,
    padding: "32px 28px",
    boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
    color: "#222",
    lineHeight: 1.7,
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
  },
  h1: { fontSize: 30, marginBottom: 4 },
  h2: { fontSize: 20, marginTop: 28, marginBottom: 8 },
  muted: { color: "#666", fontSize: 14 },
  box: {
    background: "#F5E9FE",
    border: "1px solid #E9D5FF",
    borderRadius: 10,
    padding: "16px 18px",
    marginTop: 12,
  },
  btn: {
    display: "inline-block",
    marginTop: 10,
    background: "#7C3AED",
    color: "#fff",
    padding: "10px 20px",
    borderRadius: 999,
    textDecoration: "none",
    fontWeight: 600,
  },
};

export default function DeleteAccount() {
  const subject = encodeURIComponent("Account deletion request");
  const body = encodeURIComponent(
    "Hello,\n\nI want to delete my PlanB Jobs account and data.\n\n" +
      "Registered mobile number: \n" +
      "Registered email: \n" +
      "Full name: \n\nThank you."
  );

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.h1}>Delete Your Account</h1>
        <p style={styles.muted}>
          {APP_NAME} by {COMPANY}
        </p>

        <p>
          You can ask us to delete your PlanB Jobs account and the personal data linked to it
          at any time. This page explains how, what gets deleted, and what we may keep.
        </p>

        <h2 style={styles.h2}>Fastest way: request while logged in</h2>
        <p>
          Log in to your PlanB Jobs account and fill a short form. Your account details are
          filled in for you, you only add a reason.
        </p>
        <a style={styles.btn} href="/account/delete">
          Request deletion (login required)
        </a>

        <h2 style={styles.h2}>Cannot log in? Request by email</h2>
        <ol>
          <li>
            Send an email to <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> with the
            subject "Account deletion request".
          </li>
          <li>
            Write your full name, the mobile number and the email address you registered with.
            This helps us confirm the account is yours.
          </li>
          <li>
            We may contact you on your registered mobile number or email to verify the
            request.
          </li>
          <li>
            We will delete your account within {RESPONSE_DAYS} days after verification and
            confirm by email or message.
          </li>
        </ol>

        <div style={styles.box}>
          <strong>Quick option</strong>
          <br />
          Tap the button to open a ready-made email.
          <br />
          <a
            style={styles.btn}
            href={`mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`}
          >
            Request account deletion by email
          </a>
        </div>

        <h2 style={styles.h2}>What we delete</h2>
        <ul>
          <li>Your account login (name, mobile number, email address, password).</li>
          <li>
            Your profile, resume details, skills, work history, salary and location
            preferences.
          </li>
          <li>Your saved jobs, job applications and uploaded files such as your resume.</li>
          <li>Your device notification token and any saved registration progress.</li>
          <li>
            For employer accounts: your company profile and the jobs you posted. Employer
            team members are removed from the account.
          </li>
        </ul>

        <h2 style={styles.h2}>What we may keep</h2>
        <ul>
          <li>
            Records we must keep by law, such as payment or invoice records for paid plans.
          </li>
          <li>
            Basic security and fraud-prevention logs, kept for a limited period and not linked
            to a usable profile.
          </li>
          <li>
            Messages or applications already received by an employer may remain with that
            employer, because they hold their own copy.
          </li>
        </ul>

        <h2 style={styles.h2}>Before you delete</h2>
        <p>
          Deleting your account is permanent. Your profile, applications and saved jobs cannot
          be restored. If you only want to stop notifications, you can turn them off in your
          phone settings instead.
        </p>

        <h2 style={styles.h2}>Need help?</h2>
        <p>
          Email <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>. Read our{" "}
          <a href="/privacy-policy">Privacy Policy</a> to learn how we handle your data.
        </p>
      </div>
    </div>
  );
}